module.exports = __webpack_public_path__ + "static/img/bottom4.1a54fa7f.jpg";